import { DeployStatus } from '@bm-js/atlascloud-shared'
import { TrKey } from '../cnst/translations/trKey.cnst'

type NextUIColor =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'danger'
  | undefined

export const deployStatusColorMap: Record<
  DeployStatus | 'pending',
  NextUIColor
> = {
  building: 'secondary',
  enqueued: 'secondary',
  new: 'secondary',
  processing: 'secondary',
  uploading: 'secondary',
  ready: 'success',
  error: 'danger',
  pending: 'default',
  uploaded: 'default',
  processed: 'default',
  preparing: 'default',
  prepared: 'default',
  retrying: 'default',
  pending_review: 'default',
  accepted: 'default',
  rejected: 'danger',
}

export const deployStatusTextMap: Record<DeployStatus | 'pending', TrKey> = {
  building: TrKey.deployStatusBuilding,
  enqueued: TrKey.deployStatusBuilding,
  new: TrKey.deployStatusBuilding,
  processing: TrKey.deployStatusBuilding,
  uploading: TrKey.deployStatusBuilding,
  error: TrKey.deployStatusError,
  ready: TrKey.deployStatusReady,
  pending: TrKey.deployStatusPending,
  uploaded: TrKey.deployStatusPending,
  processed: TrKey.deployStatusPending,
  preparing: TrKey.deployStatusPending,
  prepared: TrKey.deployStatusPending,
  retrying: TrKey.deployStatusPending,
  pending_review: TrKey.deployStatusPending,
  accepted: TrKey.deployStatusPending,
  rejected: TrKey.deployStatusError,
}
